// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"420":"5cb0ab69","3650":"5cb0ab69","7699":"54b1e827","7880":"5cb0ab69","9382":"f1828abe"}[chunkId] + ".chunk.css";
};